module.exports = __webpack_public_path__ + "img/gal-9.92758fee.jpeg";